var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page-wrapper"},[_c('login-dialog',{staticClass:"login-comp"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }